import { DomaineCode } from './enums/domaine-code.enum';
export class Domaine {
    static jsonMap = {
        id: 'id',
        code: { key: 'code', optional: true },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    public id: number;
    public code: DomaineCode;
    public libelle: string;
}
